import { parseBoolean } from './helpers'
import { OrderType } from './OrderModel'

export interface SettingsResponseInterface {
  [key: string]: string | number | boolean
}

export interface SettingsTabInterface {
  type: OrderType
  enabled: boolean
}

export interface SettingsInterface {
  enableSales: boolean
  enableReservation: boolean
  enableAddProducts: boolean
  tabs: SettingsTabInterface[]
}

function getTabSettingKey(type: OrderType): string {
  return `SHOW_${type.toUpperCase()}_ORDERS_LIST`
}

export function parseSettingsModel(response: SettingsResponseInterface): SettingsInterface {
  return {
    enableSales: parseBoolean(response?.CREATE_ORDERS_MANUALY),
    enableReservation: parseBoolean(response?.ENABLE_RESERVATIONS),
    enableAddProducts: parseBoolean(response?.ENABLE_OFFERS),

    tabs: Object.values(OrderType).map((type) => ({
      type,
      enabled: parseBoolean(response?.[getTabSettingKey(type)] ?? type === OrderType.all),
    })),
  }
}
